var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTourism(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 22.833c2.338 0 4.234-.597 4.234-1.333s-1.896-1.334-4.234-1.334S9.1 20.764 9.1 21.5c0 .736 1.895 1.333 4.233 1.333z",
    fill: "#0C0A0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.567 12.467L5.333 20.3 3.9 16.7h.033c1.334-.3 2.267-1.367 2.034-2.367-.234-1.033-1.5-1.6-2.834-1.333-.233.033-.433.1-.6.2L1 9.333 18.467 4.6l3.1 7.867z",
    fill: "#FF794F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 8.467l2.966 7.8",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.233 8.3L16.9 10.1l1.467 2.167-2.667-.5-1.467 1.933-.4-2.3-2.233-1.233 2.367-.734L14.3 7l1.467 1.8 2.466-.5z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 2.2l-2.1 2.034M18.967.867c0 .8-.167 1.633-.467 2.466M23 5.533l-2.533.267",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTourism;